export default __webpack_public_path__ + "static/media/tehran-univer@2x.a4cfd1f0.png";